import { render } from "./IconSansGluten.vue?vue&type=template&id=62912f2b"
import script from "./IconSansGluten.vue?vue&type=script&lang=js"
export * from "./IconSansGluten.vue?vue&type=script&lang=js"

import exportComponent from "D:\\perso\\miam\\miam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__